import type { IProduct } from '@/entities/product/model/types';

/**
 * Yapona / cart-footer rule: in stock unless a branch menu is selected
 * and the product is not active in that menu.
 * Defaults to in stock while product data is still loading (avoids out-of-stock flash).
 */
export function isProductInStock(
  product: Pick<IProduct, 'active_in_menu'> | null | undefined,
  menuId?: string | null,
): boolean {
  if (!menuId || !product) return true;
  return Boolean(product.active_in_menu);
}
